var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcRoundPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 18.4134H18.4166V25.4967C18.4166 25.8725 18.2674 26.2328 18.0017 26.4985C17.736 26.7642 17.3757 26.9134 17 26.9134C16.6243 26.9134 16.2639 26.7642 15.9982 26.4985C15.7326 26.2328 15.5833 25.8725 15.5833 25.4967V18.4134H8.49998C8.12426 18.4134 7.76392 18.2642 7.49825 17.9985C7.23257 17.7328 7.08331 17.3725 7.08331 16.9967C7.08331 16.621 7.23257 16.2607 7.49825 15.995C7.76392 15.7293 8.12426 15.5801 8.49998 15.5801H15.5833V8.49674C15.5833 8.12102 15.7326 7.76069 15.9982 7.49501C16.2639 7.22933 16.6243 7.08008 17 7.08008C17.3757 7.08008 17.736 7.22933 18.0017 7.49501C18.2674 7.76069 18.4166 8.12102 18.4166 8.49674V15.5801H25.5C25.8757 15.5801 26.236 15.7293 26.5017 15.995C26.7674 16.2607 26.9166 16.621 26.9166 16.9967C26.9166 17.3725 26.7674 17.7328 26.5017 17.9985C26.236 18.2642 25.8757 18.4134 25.5 18.4134Z",
    fill: "#00FFF0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRoundPlus);
export default __webpack_public_path__ + "static/media/ic_round-plus.166844a8a6b70b0d062d3e4b8eb03eab.svg";
export { ForwardRef as ReactComponent };